import { render, staticRenderFns } from "./AntecedentesPersonales.vue?vue&type=template&id=3b9150e2&scoped=true"
import script from "./AntecedentesPersonales.vue?vue&type=script&lang=js"
export * from "./AntecedentesPersonales.vue?vue&type=script&lang=js"
import style0 from "./AntecedentesPersonales.vue?vue&type=style&index=0&id=3b9150e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9150e2",
  null
  
)

export default component.exports